import { render, staticRenderFns } from "./Linktree.vue?vue&type=template&id=22728cae&scoped=true&"
import script from "./Linktree.vue?vue&type=script&lang=js&"
export * from "./Linktree.vue?vue&type=script&lang=js&"
import style0 from "./Linktree.vue?vue&type=style&index=0&id=22728cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22728cae",
  null
  
)

export default component.exports